import React from "react";
import { Row } from "react-grid-system";
import BodySmall from "../atoms/typography/BodySmall";
import { ChevronSmallRightIcon } from "../atoms/icons/ChevronIcons";
import { theme } from "../../theme";
import { generatePath, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { routes } from "../../utils/routes";

export type BreadcrumbFrom =
  | string
  | {
      routeId: string;
      params?: Record<string, string>;
    };

interface BreadcrumbProps {
  from: BreadcrumbFrom;
  currentTitle: string;
}

const ClickableText = styled(BodySmall)`
  cursor: pointer;
  color: ${theme.colors.textSecondary};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Breadcrumb: React.FC<BreadcrumbProps> = ({ from, currentTitle }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const normalized = typeof from === "string" ? { routeId: from } : from;

  const route = routes.find((x) => x.id === normalized.routeId);

  const handleNavigate = () => {
    if (!route) return;

    const path = normalized.params
      ? generatePath(route.path, normalized.params)
      : route.path;

    navigate(path);
  };

  return (
    <Row nogutter align="center">
      <ClickableText onClick={handleNavigate}>
        {route ? t(route.titleKey) : ""}
      </ClickableText>
      <ChevronSmallRightIcon color={theme.colors.textSecondary} />
      <BodySmall>{currentTitle}</BodySmall>
    </Row>
  );
};

export default Breadcrumb;
